import { render, staticRenderFns } from "./ColumnBasic.vue?vue&type=template&id=f485bbd8&scoped=true&"
import script from "./ColumnBasic.vue?vue&type=script&lang=js&"
export * from "./ColumnBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f485bbd8",
  null
  
)

export default component.exports